<p-dialog header="Upload Documents" [modal]="true" [(visible)]="visibleDriverUploadDoc"
          (onHide)="cancel()"
          [style]="{width: '670px', height: '620px'}">
    <div *ngIf="isLoading">
        <p-progressSpinner styleClass="w-4rem h-4rem"
                           strokeWidth="8"
                           fill="var(--surface-ground)"
                           animationDuration=".5s" />
    </div>
    <div *ngIf="!isLoading">
        <p-tabMenu [model]="menuItems" [scrollable]="true" [activeItem]="menuItems[0]"></p-tabMenu>

        <p-scrollPanel [style]="{width:'100%', height: 'calc(44vh)'}"
                       [styleClass]="'app-scrollpanel'">
            <div class="add-doc-sub-title mt-4 mb-4">
                Accepted Files: .pdf, .jpg
            </div>

            <div *ngIf="activeTab === menuTab.Identification">
                <div class="col-12 p-0 flex-row flex-wrap">
                    <div class="col-6 p-0 mb-3 pr-2">
                        <div class="add-doc-label">Professional Driver’s License (Front)</div>
                        <div class="mt-3">
                            <div class="add-doc-upload-field"
                                 *ngIf="riderUploadDocModel.DriverProfessionalLicenceFrontImageUrlIsLoading || !riderUploadDocModel.DriverProfessionalLicenceFrontImageUrl">
                                <div class="add-doc-upload-field__btn-block" *ngIf="!riderUploadDocModel.DriverProfessionalLicenceFrontImageUrlIsLoading">
                                    <div class="add-doc-upload-field__title mb-2">Drop files here to upload…</div>
                                    <div>
                                        <input style="display: none" type="file" id="vehicleFront1" (change)="fileBrowseHandler($event, 'DriverProfessionalLicenceFrontImageUrl')">
                                        <label class="bluedark-btn" for="vehicleFront1">Browse File</label>
                                    </div>
                                </div>
                                <div class="add-doc-upload-field__progress-bar" *ngIf="riderUploadDocModel.DriverProfessionalLicenceFrontImageUrlIsLoading">
                                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                            </div>
                            <div class="add-doc-img-block-second"
                                 *ngIf="!riderUploadDocModel.DriverProfessionalLicenceFrontImageUrlIsLoading && riderUploadDocModel.DriverProfessionalLicenceFrontImageUrl">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="Content/xpress-app/images/operator/signup/file-jpg.svg" width="24px" alt="file" />
                                    <div class="mt-1 common-font file-name">License(front image)</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file"
                                         (click)="deleteUpload('DriverProfessionalLicenceFrontImageUrl')">
                                </div>
                            </div>
                        </div>                        
                    </div>
                    <div class="col-6 p-0 mb-3 pl-2">
                        <div class="add-doc-label">Professional Driver’s License (Back)</div>
                        <div class="mt-3">
                            <div class="add-doc-upload-field"
                                 *ngIf="riderUploadDocModel.DriverProfessionalLicenceBackImageUrlIsLoading || !riderUploadDocModel.DriverProfessionalLicenceBackImageUrl">
                                <div class="add-doc-upload-field__btn-block" *ngIf="!riderUploadDocModel.DriverProfessionalLicenceBackImageUrlIsLoading">
                                    <div class="add-doc-upload-field__title mb-2">Drop files here to upload…</div>
                                    <div>
                                        <input style="display: none" type="file" id="vehicleFront2" (change)="fileBrowseHandler($event, 'DriverProfessionalLicenceBackImageUrl')">
                                        <label class="bluedark-btn" for="vehicleFront2">Browse File</label>
                                    </div>
                                </div>
                                <div class="add-doc-upload-field__progress-bar" *ngIf="riderUploadDocModel.DriverProfessionalLicenceBackImageUrlIsLoading">
                                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                            </div>
                            <div class="add-doc-img-block-second"
                                 *ngIf="!riderUploadDocModel.DriverProfessionalLicenceBackImageUrlIsLoading && riderUploadDocModel.DriverProfessionalLicenceBackImageUrl">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="Content/xpress-app/images/operator/signup/file-jpg.svg" width="24px" alt="file" />
                                    <div class="mt-1 common-font file-name">License(back image)</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file"
                                         (click)="deleteUpload('DriverProfessionalLicenceBackImageUrl')">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 p-0 mb-3 pl-2">
                        <div class="col-6 p-0">
                            <div class="add-doc-label">Professional Driver’s License Expiry At</div>
                            <div class="mt-3">
                                <p-calendar [(ngModel)]="riderUploadDocModel.DriverProfessionalLicenceExpiryAt" [appendTo]="'body'" [minDate]="minDate" />
                            </div>
                        </div>                        
                    </div>

                    <div class="col-6 p-0 mb-3 pr-2">
                        <div class="add-doc-label">NBI Clearance</div>
                        <div class="mt-3">
                            <div class="add-doc-upload-field"
                                 *ngIf="riderUploadDocModel.DriverNBIClearanceImageUrlIsLoading || !riderUploadDocModel.DriverNBIClearanceImageUrl">
                                <div class="add-doc-upload-field__btn-block" *ngIf="!riderUploadDocModel.DriverNBIClearanceImageUrlIsLoading">
                                    <div class="add-doc-upload-field__title mb-2">Drop files here to upload…</div>
                                    <div>
                                        <input style="display: none" type="file" id="vehicleFront3" (change)="fileBrowseHandler($event, 'DriverNBIClearanceImageUrl')">
                                        <label class="bluedark-btn" for="vehicleFront3">Browse File</label>
                                    </div>
                                </div>
                                <div class="add-doc-upload-field__progress-bar" *ngIf="riderUploadDocModel.DriverNBIClearanceImageUrlIsLoading">
                                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                            </div>
                            <div class="add-doc-img-block-second"
                                 *ngIf="!riderUploadDocModel.DriverNBIClearanceImageUrlIsLoading && riderUploadDocModel.DriverNBIClearanceImageUrl">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="Content/xpress-app/images/operator/signup/file-jpg.svg" width="24px" alt="file" />
                                    <div class="mt-1 common-font file-name">NBI Clearance</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file"
                                         (click)="deleteUpload('DriverNBIClearanceImageUrl')">
                                </div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="add-doc-label">NBI Clearance Expiry At</div>
                            <div class="mt-3">
                                <p-calendar [(ngModel)]="riderUploadDocModel.DriverNBIClearanceExpiryAt" [appendTo]="'body'" [minDate]="minDate" />
                            </div>
                        </div>
                    </div>
                    <div class="col-6 p-0 mb-3 pl-2">
                        <div class="add-doc-label">Driver ID</div>
                        <div class="mt-3">
                            <div class="add-doc-upload-field"
                                 *ngIf="riderUploadDocModel.RidesharingAppImageUrlIsLoading || !riderUploadDocModel.RidesharingAppImageUrl">
                                <div class="add-doc-upload-field__btn-block" *ngIf="!riderUploadDocModel.RidesharingAppImageUrlIsLoading">
                                    <div class="add-doc-upload-field__title mb-2">Drop files here to upload…</div>
                                    <div>
                                        <input style="display: none" type="file" id="vehicleFront4" (change)="fileBrowseHandler($event, 'RidesharingAppImageUrl')">
                                        <label class="bluedark-btn" for="vehicleFront4">Browse File</label>
                                    </div>
                                </div>
                                <div class="add-doc-upload-field__progress-bar" *ngIf="riderUploadDocModel.RidesharingAppImageUrlIsLoading">
                                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                            </div>
                            <div class="add-doc-img-block-second"
                                 *ngIf="!riderUploadDocModel.RidesharingAppImageUrlIsLoading && riderUploadDocModel.RidesharingAppImageUrl">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="Content/xpress-app/images/operator/signup/file-jpg.svg" width="24px" alt="file" />
                                    <div class="mt-1 common-font file-name">Driver ID</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file"
                                         (click)="deleteUpload('RidesharingAppImageUrl')">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="activeTab === menuTab.VehicleDocuments">
                <div class="col-12 p-0 flex-row flex-wrap">
                    <div class="col-6 p-0 mb-3 pr-2">
                        <div class="add-doc-label">Official Receipt</div>
                        <div class="mt-3">
                            <div class="add-doc-upload-field"
                                 *ngIf="riderUploadDocModel.LTOOfficialReceiptImageUrlIsLoading || !riderUploadDocModel.LTOOfficialReceiptImageUrl">
                                <div class="add-doc-upload-field__btn-block" *ngIf="!riderUploadDocModel.LTOOfficialReceiptImageUrlIsLoading">
                                    <div class="add-doc-upload-field__title mb-2">Drop files here to upload…</div>
                                    <div>
                                        <input style="display: none" type="file" id="vehicleFront5" (change)="fileBrowseHandler($event, 'LTOOfficialReceiptImageUrl')">
                                        <label class="bluedark-btn" for="vehicleFront5">Browse File</label>
                                    </div>
                                </div>
                                <div class="add-doc-upload-field__progress-bar" *ngIf="riderUploadDocModel.LTOOfficialReceiptImageUrlIsLoading">
                                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                            </div>
                            <div class="add-doc-img-block-second"
                                 *ngIf="!riderUploadDocModel.LTOOfficialReceiptImageUrlIsLoading && riderUploadDocModel.LTOOfficialReceiptImageUrl">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="Content/xpress-app/images/operator/signup/file-jpg.svg" width="24px" alt="file" />
                                    <div class="mt-1 common-font file-name">LTO Official Receipt</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file"
                                         (click)="deleteUpload('LTOOfficialReceiptImageUrl')">
                                </div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="add-doc-label">Official Receipt Expiry At</div>
                            <div class="mt-3">
                                <p-calendar [(ngModel)]="riderUploadDocModel.LTOOfficialReceiptExpireAt" [appendTo]="'body'" [minDate]="minDate" />
                            </div>
                        </div>
                    </div>
                    <div class="col-6 p-0 mb-3 pl-2">
                        <div class="add-doc-label">Certificate of Registration</div>
                        <div class="mt-3">
                            <div class="add-doc-upload-field"
                                 *ngIf="riderUploadDocModel.CertificateRegistrationImageUrlIsLoading || !riderUploadDocModel.CertificateRegistrationImageUrl">
                                <div class="add-doc-upload-field__btn-block" *ngIf="!riderUploadDocModel.CertificateRegistrationImageUrlIsLoading">
                                    <div class="add-doc-upload-field__title mb-2">Drop files here to upload…</div>
                                    <div>
                                        <input style="display: none" type="file" id="vehicleFront6" (change)="fileBrowseHandler($event, 'CertificateRegistrationImageUrl')">
                                        <label class="bluedark-btn" for="vehicleFront6">Browse File</label>
                                    </div>
                                </div>
                                <div class="add-doc-upload-field__progress-bar" *ngIf="riderUploadDocModel.CertificateRegistrationImageUrlIsLoading">
                                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                            </div>
                            <div class="add-doc-img-block-second"
                                 *ngIf="!riderUploadDocModel.CertificateRegistrationImageUrlIsLoading && riderUploadDocModel.CertificateRegistrationImageUrl">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="Content/xpress-app/images/operator/signup/file-jpg.svg" width="24px" alt="file" />
                                    <div class="mt-1 common-font file-name">Certificate of Registration</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file"
                                         (click)="deleteUpload('CertificateRegistrationImageUrl')">
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-6 p-0 mb-3 pr-2">
                        <div class="add-doc-label">SPA</div>
                        <div class="mt-3">
                            <div class="add-doc-upload-field"
                                 *ngIf="riderUploadDocModel.SPAImageUrlIsLoading || !riderUploadDocModel.SPAImageUrl">
                                <div class="add-doc-upload-field__btn-block" *ngIf="!riderUploadDocModel.SPAImageUrlIsLoading">
                                    <div class="add-doc-upload-field__title mb-2">Drop files here to upload…</div>
                                    <div>
                                        <input style="display: none" type="file" id="vehicleFront7" (change)="fileBrowseHandler($event, 'SPAImageUrl')">
                                        <label class="bluedark-btn" for="vehicleFront7">Browse File</label>
                                    </div>
                                </div>
                                <div class="add-doc-upload-field__progress-bar" *ngIf="riderUploadDocModel.SPAImageUrlIsLoading">
                                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                            </div>
                            <div class="add-doc-img-block-second"
                                 *ngIf="!riderUploadDocModel.SPAImageUrlIsLoading && riderUploadDocModel.SPAImageUrl">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="Content/xpress-app/images/operator/signup/file-jpg.svg" width="24px" alt="file" />
                                    <div class="mt-1 common-font file-name">SPA</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file"
                                         (click)="deleteUpload('SPAImageUrl')">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-6 p-0 mb-3 pl-2">
                        <div class="add-doc-label">AL</div>
                        <div class="mt-3">
                            <div class="add-doc-upload-field"
                                 *ngIf="riderUploadDocModel.AuthorizationLetterImageUrlIsLoading || !riderUploadDocModel.AuthorizationLetterImageUrl">
                                <div class="add-doc-upload-field__btn-block" *ngIf="!riderUploadDocModel.AuthorizationLetterImageUrlIsLoading">
                                    <div class="add-doc-upload-field__title mb-2">Drop files here to upload…</div>
                                    <div>
                                        <input style="display: none" type="file" id="vehicleFront8" (change)="fileBrowseHandler($event, 'AuthorizationLetterImageUrl')">
                                        <label class="bluedark-btn" for="vehicleFront8">Browse File</label>
                                    </div>
                                </div>
                                <div class="add-doc-upload-field__progress-bar" *ngIf="riderUploadDocModel.AuthorizationLetterImageUrlIsLoading">
                                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                            </div>
                            <div class="add-doc-img-block-second"
                                 *ngIf="!riderUploadDocModel.AuthorizationLetterImageUrlIsLoading && riderUploadDocModel.AuthorizationLetterImageUrl">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="Content/xpress-app/images/operator/signup/file-jpg.svg" width="24px" alt="file" />
                                    <div class="mt-1 common-font file-name">AL</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file"
                                         (click)="deleteUpload('AuthorizationLetterImageUrl')">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="activeTab === menuTab.TNVSDocuments">
                <div class="col-12 p-0 flex-row flex-wrap">
                    <div class="col-6 p-0 mb-3 pr-2">
                        <div class="add-doc-label">CPC Document</div>
                        <div class="mt-3">
                            <div class="add-doc-upload-field"
                                 *ngIf="riderUploadDocModel.CertificatePublicConvenienceImageUrlIsLoading || !riderUploadDocModel.CertificatePublicConvenienceImageUrl">
                                <div class="add-doc-upload-field__btn-block" *ngIf="!riderUploadDocModel.CertificatePublicConvenienceImageUrlIsLoading">
                                    <div class="add-doc-upload-field__title mb-2">Drop files here to upload…</div>
                                    <div>
                                        <input style="display: none" type="file" id="vehicleFront9" (change)="fileBrowseHandler($event, 'CertificatePublicConvenienceImageUrl')">
                                        <label class="bluedark-btn" for="vehicleFront9">Browse File</label>
                                    </div>
                                </div>
                                <div class="add-doc-upload-field__progress-bar" *ngIf="riderUploadDocModel.CertificatePublicConvenienceImageUrlIsLoading">
                                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                            </div>
                            <div class="add-doc-img-block-second"
                                 *ngIf="!riderUploadDocModel.CertificatePublicConvenienceImageUrlIsLoading && riderUploadDocModel.CertificatePublicConvenienceImageUrl">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="Content/xpress-app/images/operator/signup/file-jpg.svg" width="24px" alt="file" />
                                    <div class="mt-1 common-font file-name">Certificate Public Convenience</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file"
                                         (click)="deleteUpload('CertificatePublicConvenienceImageUrl')">
                                </div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="add-doc-label">CPC Expiry At</div>
                            <div class="mt-3">
                                <p-calendar [(ngModel)]="riderUploadDocModel.CertificatePublicConvenienceExpireAt" [appendTo]="'body'" [minDate]="minDate" />
                            </div>
                        </div>
                    </div>
                    <div class="col-6 p-0 mb-3 pl-2">
                        <div class="add-doc-label">PA Document</div>
                        <div class="mt-3">
                            <div class="add-doc-upload-field"
                                 *ngIf="riderUploadDocModel.ProvisionalAuthorityImageUrlIsLoading || !riderUploadDocModel.ProvisionalAuthorityImageUrl">
                                <div class="add-doc-upload-field__btn-block" *ngIf="!riderUploadDocModel.CertificateRegistrationImageUrlIsLoading">
                                    <div class="add-doc-upload-field__title mb-2">Drop files here to upload…</div>
                                    <div>
                                        <input style="display: none" type="file" id="vehicleFront10" (change)="fileBrowseHandler($event, 'ProvisionalAuthorityImageUrl')">
                                        <label class="bluedark-btn" for="vehicleFront10">Browse File</label>
                                    </div>
                                </div>
                                <div class="add-doc-upload-field__progress-bar" *ngIf="riderUploadDocModel.ProvisionalAuthorityImageUrlIsLoading">
                                    <p-progressBar mode="indeterminate" [style]="{'height': '6px'}" />
                                </div>
                            </div>
                            <div class="add-doc-img-block-second"
                                 *ngIf="!riderUploadDocModel.ProvisionalAuthorityImageUrlIsLoading && riderUploadDocModel.ProvisionalAuthorityImageUrl">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="Content/xpress-app/images/operator/signup/file-jpg.svg" width="24px" alt="file" />
                                    <div class="mt-1 common-font file-name">Provisional Authority</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file"
                                         (click)="deleteUpload('ProvisionalAuthorityImageUrl')">
                                </div>
                            </div>
                        </div>
                        <div class="mt-3">
                            <div class="add-doc-label">PA Expiry At</div>
                            <div class="mt-3">
                                <p-calendar [(ngModel)]="riderUploadDocModel.ProvisionalAuthorityExpireAt" [appendTo]="'body'" [minDate]="minDate" />
                            </div>
                        </div>
                    </div>

                    <div class="col-6 p-0 mb-3 pr-2">
                        <div class="add-doc-label">CPC/PA Case Number</div>
                        <div class="mt-3">
                            <input type="text" placeholder="Enter no."
                                   [(ngModel)]="riderUploadDocModel.PaOrCpcCaseNumber" />
                        </div>
                    </div>
                </div>
            </div>
        </p-scrollPanel>

        <div class="flex flex-row justify-content-end gap-2 mt-2">
            <button pButton type="button" class="outlined-white-btn" label="Cancel" (click)="cancel()"></button>
            <button pButton type="button" class="bluedark-btn" label="Upload" [disabled]="checkFieldsForDisabledBtn()" (click)="updateLegalDocuments()"></button>
        </div>
    </div>
</p-dialog>
